import {View} from "@variocube/cube-ui";
import * as React from "react";
import {useCallback} from "react";
import {Category, Product} from "./types";
import {VendingViewHeader} from "./header";
import {GridItem, GridViewContent} from "./grid";

export interface ProductsViewProps {
    category: Category;
    products: Product[];
    onProduct: (product: Product) => void;
    onBack: () => void;
}

export function ProductsView({category, products, onProduct, onBack}: ProductsViewProps) {
    return (
        <View>
            <VendingViewHeader title={category.name} onBack={onBack}/>
            <GridViewContent>
                {products.map((p) => (
                    <ProductListItem
                        key={p.id}
                        product={p}
                        onSelect={onProduct}
                    />
                ))}
            </GridViewContent>
        </View>
    );
}

interface CategoryListItemProps {
    product: Product;
    onSelect: (product: Product) => void;
}

function ProductListItem({product, onSelect}: CategoryListItemProps) {
    const handleClick = useCallback(() => onSelect(product), [product, onSelect]);
    return (
        <GridItem onClick={handleClick} text={product.name} image={product.image}/>
    );
}
